import { atom } from "jotai";
import useHttp from "../hooks/useHttp";

export const brandsLoadingStatusAtom = atom("idle");
export const allBrandInfoAtom = atom([]);

export const fetchBrands = atom(null, async (get, set, brandId) => {
  const { getBrands } = useHttp();

  set(brandsLoadingStatusAtom, "loading");
  getBrands(brandId)
    .then((response) => set(allBrandInfoAtom, response))
    .finally(() => set(brandsLoadingStatusAtom, "idle"));
});
